<div
  class="ring-light"
  [style.border-width]="borderWidth"
  [style.border-color]="borderColor"
  [style.box-shadow]="boxShadow"
  [style.mask]="mask"
></div>
